const RECEIVE_ALL_BRANDS_FOLLOWING = 'src/brands/RECEIVE_ALL_BRANDS_FOLLOWING' as const;
const CLEAR_ALL_BRANDS_FOLLOWING = 'src/brands/CLEAR_ALL_BRANDS_FOLLOWING' as const;

export default {
  CLEAR_ALL_BRANDS_FOLLOWING,
  RECEIVE_ALL_BRANDS_FOLLOWING
};
